import { render, staticRenderFns } from "./FundingProjectDetails.vue?vue&type=template&id=088c914b&scoped=true&"
import script from "./FundingProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./FundingProjectDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FundingProjectDetails.vue?vue&type=style&index=0&id=088c914b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c914b",
  null
  
)

export default component.exports